class InspeccionData {
    constructor({
      tipoVehiculo = null,
      patente = null,
      telefono = null,
      companiaIndex = null,
      poseeGNC = false,
      airbagExplotado = false,
      es0KM = false,
      sinPatente = false,
    } = {}) {
      this.tipoVehiculo = tipoVehiculo;
      this.patente = patente;
      this.telefono = telefono;
      this.companiaIndex = companiaIndex;
      this.poseeGNC = poseeGNC;
      this.airbagExplotado = airbagExplotado;
      this.es0KM = es0KM;
      this.sinPatente = sinPatente;
    }
  
    toJson() {
      return {
        tipo: this.tipoVehiculo,
        dominioHidden: this.patente,
        telefonoHidden: this.telefono,
        aseguradoraHidden: this.companiaIndex,
        chkgncHidden: this.poseeGNC,
        chkairbagHidden: this.airbagExplotado,
        chk0kmHidden: this.es0KM,
      };
    }
  }
  
  export default InspeccionData;